import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';

const UserProfilePage = () => {
  const { user } = useSelector((state: RootState) => state.account);
  return (
    <div className="h-full flex justify-center">
      <div className="w-full sm:w-full md:w-1/2 lg:w-1/3 xl:w-1/4">
        <div className="shadow">{user.name}</div>
      </div>
    </div>
  );
};

export default UserProfilePage;
